<div fxFlex="100" fxFlex.gt-sm="100">
    <h2 class="text-muted text-center">Edit Credit Card Details</h2>
    <form class="mt-1" [formGroup]="creditCardForm" (ngSubmit)="updateCreditCard()" novalidate>
        <fieldset class="credit-card-fieldset" *ngIf="!!creditCardDetails">
            <legend>Credit Card Details</legend>
            <div fxLayout="row wrap">
                <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Card number</mat-label>
                        <input matInput placeholder="Card number" 
                            value="xxxx{{creditCardDetails.last4}}" disabled>
                    </mat-form-field>
                </div>
                <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Expiration Date</mat-label>
                        <input matInput placeholder="MM/YY" 
                            value="{{creditCardDetails.expirydate}}" 
                            disabled>
                    </mat-form-field>
                </div>
                <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>CVC Code</mat-label>
                        <input matInput placeholder="CVC Code" 
                            value="{{creditCardDetails.cardType === 'amex' ? 'xxxx' : 'xxx'}}" disabled>
                    </mat-form-field>
                </div>
            </div>
        </fieldset>
        <fieldset class="credit-card-fieldset">
            <legend>Billing Address</legend>
            <div fxLayout="row wrap"> 
                <div fxFlex="100" class="px-1">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Address</mat-label>
                        <input matInput placeholder="Address" formControlName="address"> 
                        <mat-error *ngIf="creditCardForm.controls.address.errors?.required">Address is required</mat-error>
                        <mat-error *ngIf="creditCardForm.controls.address.errors?.maxlength">
                            Maximum only 60 characters are allowed
                        </mat-error>
                        <mat-error *ngIf="creditCardForm.controls.address.hasError('validation')">
                            {{creditCardForm.controls.address.errors.message}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div fxFlex="100" fxFlex.gt-sm="40" class="px-1">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>City</mat-label>
                        <input matInput placeholder="City" formControlName="city"> 
                        <mat-error *ngIf="creditCardForm.controls.city.errors?.required">City is required</mat-error>
                        <mat-error *ngIf="creditCardForm.controls.city.hasError('validation')">
                            {{creditCardForm.controls.city.errors.message}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div fxFlex="100" fxFlex.gt-sm="40" class="px-1">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>State</mat-label>
                        <input matInput placeholder="State" formControlName="state"> 
                        <mat-error *ngIf="creditCardForm.controls.state.errors?.required">State is required</mat-error>
                        <mat-error *ngIf="creditCardForm.controls.state.hasError('validation')">
                            {{creditCardForm.controls.state.errors.message}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div fxFlex="100" fxFlex.gt-sm="20" class="px-1">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Zip Code</mat-label>
                        <input inputmode="numeric" matInput placeholder="Zip Code" formControlName="zipcode"> 
                        <mat-error *ngIf="creditCardForm.controls.zipcode.errors?.required">Zip Code is required</mat-error>
                        <mat-error *ngIf="creditCardForm.controls.zipcode.hasError('validation')">
                            {{creditCardForm.controls.zipcode.errors.message}}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </fieldset>
        <div fxLayout="row" fxLayoutAlign="flex-end center" fxLayoutGap="10px" class="p-1"> 
            <mat-spinner-button [options] = "editButtonOptions"  [disabled] = "editButtonOptions.active === true" mat-raised-button color="primary">Update</mat-spinner-button>
        </div>
    </form>
</div>